"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@/components/common/tabs/tab-list");
require("@/components/common/tabs/tab");
require("@/components/common/tabs/tab-panel");
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDZDQUEwQztBQUMxQyx3Q0FBcUM7QUFDckMsOENBQTJDIn0=